import { authenticatedApiClient } from '../axios';
import { UniversalButtonData } from '@cobu/types';
import { BUILDING_UNIVERSAL_BUTTON_ENDPOINT } from '../config/api';

/**
 * User service for handling user-related operations
 */
class UniversalButtonService {
  /**
   * Get universal button data
   */
  async getUniversalButtonData(buildingUuid: string): Promise<UniversalButtonData> {
    const response = await authenticatedApiClient.get<UniversalButtonData>(`${BUILDING_UNIVERSAL_BUTTON_ENDPOINT}/${buildingUuid}/universal-button`);
    return response;
  }
}

// Export a singleton instance
const universalButtonServiceInstance = new UniversalButtonService();
export default universalButtonServiceInstance; 